'use client'

import { useEffect } from 'react'
import Clarity from '@microsoft/clarity'

export function ClarityInit() {
  useEffect(() => {
    Clarity.init('wfny7xcneh')
  }, [])

  return null
}
